import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { ApiResponse } from "src/app/models/apiresponse";
import { CustomerAcknowledgementService } from "src/app/services/customer-acknowledgement.service";
import { CAConstant } from "src/app/shared/constant";
import { CustomerAcknowledgementFormComponent } from "../customer-acknowledgement-form/customer-acknowledgement-form.component";
import moment from "moment";
@Component({
    selector: "app-welcome",
    templateUrl: "./welcome.component.html",
    styleUrls: ["./welcome.component.scss"],
    standalone: false
})
export class WelcomeComponent implements OnInit {

  @ViewChild("content", { static: true }) content: ElementRef;
  @ViewChild(CustomerAcknowledgementFormComponent) customerAcknowledgement: CustomerAcknowledgementFormComponent;

  passwordRequired: boolean = false;
  orderAccepted: boolean = true;
  linkExpired: boolean = false;
  isExpired: boolean = false;

  channelCode: string = "";
  caId: string = "";
  rId: string = "";
  acceptString: string = "I Accept";

  passwordForm: UntypedFormGroup;
  SearchGrid: CustomerAcknowledgementFormComponent;
  intervalId: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private customerAcknowledgementService: CustomerAcknowledgementService,
    private config: NgbModalConfig,
    private fb: UntypedFormBuilder,
    private modalService: NgbModal
  ) {
    //this.intervalId = setInterval(this.checkCAStatus, CAConstant.EXPIRED_TIME);  //900000 = 15minutes

    this.intervalId = setInterval(()=> {
      this.checkCAStatus(); 
    }, CAConstant.EXPIRED_TIME); 

    this.config.backdrop = "static";
    this.config.keyboard = false;

    this.passwordForm = this.fb.group({
      password: [
        "",
        [Validators.required, Validators.maxLength(6), Validators.minLength(6)],
      ],
    });
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((p) => {
      this.rId = p["rid"];
      this.caId = p["caid"];
    });
    
    /** Logic Check Priority
     * 1. check CA status
     * 2. If exists and havent accept consent, get channel code
     * 3. Based on channel code, check rid validity
     * 4. Proceed to get order / prompt dialog
     */
    this.checkCAStatus();
  }

  async checkCAStatus() {
    if (this.isExpired) {
      clearInterval(this.intervalId);
      return;
    }

    if (this.caId) {
      await this.customerAcknowledgementService
        .checkStatus(this.caId)
        .subscribe((val) => {
          if (val.status === CAConstant.SUCCESS_STATUS) {
            let status = val.responseData.caStatus.status;

            if (status.toLowerCase() === CAConstant.ACCEPTED_STATUS) {  // accepted
              this.orderAccepted = true;
              window.alert(`${CAConstant.ALREADY_ACCEPTED} \nDate : ${ moment(val.responseData.caStatus.date).format("DD/MM/YYYY")}\nTime : ${ moment(val.responseData.caStatus.date).format("hh:mm a")}`);
            } else { //not accepted
              this.orderAccepted = false;
              if (status.toLowerCase() === CAConstant.VERIFICATION_STATUS || status.toLowerCase() === CAConstant.VERIFIED_STATUS) { //verification
                this.passwordRequired = true;
                this.openPasswordModalPopUp();
              } else if ( status.toLowerCase() === CAConstant.EXPIRED_STATUS) { //expired
                this.isExpired = true;
                clearInterval(this.intervalId);
                return;
              } else {
                this.passwordRequired = false;
                this.customerAcknowledgement?.getOrderDetails();
              }
            }
          } else {
            this.handleError(val);
          }
        });
    }
  }

  onSubmit() {
    let value = this.passwordForm.controls.password.value;
    
    this.customerAcknowledgementService
      .verifyPassword(this.caId, value)
      .subscribe((res) => {
        if (res.status === CAConstant.SUCCESS_STATUS) {
          let result = res.responseData;
          if (result.status === CAConstant.SUCCESS_STATUS) {
            this.dismissAll();
            this.passwordRequired = false;
            this.customerAcknowledgement?.getOrderDetails();
          } else {
            switch (result.msg) {
              case CAConstant.IDVALUE_MAXATTEMPT:
                window.alert(CAConstant.UNABLE_TO_PROCEED);
                break;
              case CAConstant.IDVALUE_MISMATCHED:
                window.alert(CAConstant.PASSWORD_MISMATCHED);
                break;
              default:
                window.alert(CAConstant.ORDER_NOT_EXISTS);
                break;
            }
          }
        } else {
          this.handleError(res);
        }
      });
  }
   
  openPasswordModalPopUp() {
    this.modalService.open(this.content, {
      ariaLabelledBy: "modal-basic-title",
      centered: true
    });
  }

  dismissAll(){
    this.modalService.dismissAll();
  }

  private handleError(error: ApiResponse) {
    if (error.violations) {
      let message = "";
      for (const violation of (error as ApiResponse).violations) {
        message += violation.message + " ";
      }
      alert(message);
    } else {
      alert("Error: " + error.message);
    }
  }

}

